var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('section',{staticClass:"home-page-wrapper font-body-premium",attrs:{"id":"home"}},[_c('Banner'),_c('SiteInfo'),_c('SanPhamTieuBieu'),_c('LichHoatDong',{attrs:{"ongoing-activities":_vm.ongoingActivities,"daily-programs":_vm.dailyPrograms,"main-activities":_vm.mainActivities,"support-activities":_vm.supportActivities}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }